export const MONTHLY_OVERVIEW_FORM_CONTROLS = {
  SHOW_HOME_WIDGET_TIME_WORKED_MONTHLY_TARGET:
    'showHomeWidgetTimeWorkedMonthlyTarget',
  SHOW_HOME_WIDGET_BALANCE_OVERTIME_ACCOUNT:
    'showHomeWidgetBalanceOvertimeAccount',
  SHOW_DASHBOARD: 'showDashboard',
  SHOW_DASHBOARD_WORKING_TIME: 'showDashboardWorkingTime',
  SHOW_DASHBOARD_OVERTIME_AND_OTHER_ACCOUNTS:
    'showDashboardOvertimeAndOtherAccounts',
  SHOW_DASHBOARD_PAY_PREMIUMS: 'showDashboardPayPremiums',
  SHOW_DASHBOARD_OTHER: 'showDashboardOther',
  SHOW_DASHBOARD_TIMESHEET: 'showDashboardTimesheet',
} as const;
